import ApiService from "../ApiService";
const user = JSON.parse(localStorage.getItem("user"));

export default class PickupService {
  static getList = async (params) => {
    let num, cursor, keyword, type, property;
    if (params.num && params.num !== "") {
      num = `&num=${params.num}`;
    }
    if (params.cursor && params.cursor !== "") {
      cursor = `&cursor=${params.cursor}`;
    }
    if (params.keyword && params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }

    const instance = await ApiService();
    return instance.get(`/pickup?${num || ""}${cursor || ""}${keyword || ""}`);
  };

  static storeData = async (data) => {
    const instance = await ApiService();
    const params = {
      id: data.id,
      name: data.name,
      image_url: data.image_url,
      description: data.description,
      floor: data.floor,
      latitude: data.latitude,
      longitude: data.longitude,
      type: data.type,
      property: {
        id: data.property_id
      }
    }
    return instance.post(`/pickup`, params);
  };

  static putData = async (id, data) => {
    const instance = await ApiService();
    const params = {
      id: data.id,
      name: data.name,
      image_url: data.image_url,
      description: data.description,
      floor: data.floor,
      latitude: data.latitude,
      longitude: data.longitude,
      type: data.type,
      property: {
        id: data.property_id
      }
    }
    return instance.put(`/pickup/${id}`, params);
  };
}
